import React, { FC } from 'react';
import { BaseComponentProps } from '../../../../types';
import MobileViewWidget from './MobileViewWidget';

const MobileWidget: FC<BaseComponentProps> = (props) => (
  <MobileViewWidget {...props} />
);

export default MobileWidget;
